import React from 'react';
import { useTranslation } from '../i18n';
import { linkifyText } from '../utils/helpers';
import StructuredDayItemCard from './StructuredDayItemCard';

export default function StructuredMessageRenderer({ structuredMessage }) {
  const { t } = useTranslation();
  const introduction = structuredMessage.introduction || '';
  const days = Array.isArray(structuredMessage.days) ? structuredMessage.days : [];
  const finalization = structuredMessage.finalization || '';
  const recommendations = Array.isArray(structuredMessage.recommendations) ? structuredMessage.recommendations : [];

  if (days.length > 0) {
    return (
      <div className="structured-message">
        {introduction && (
          <div className="message-text structured-message-introduction">
            {linkifyText(introduction)}
          </div>
        )}

        {days.map((day, index) => {
          const dayItems = Array.isArray(day?.items) ? day.items : [];
          const dayTitle = day?.title || `${t('item.day')} ${index + 1}`;

          return (
            <section
              key={`day-${index}`}
              className="structured-day-block"
            >
              <h3 className="structured-day-title">{dayTitle}</h3>

              {day?.content && (
                <div className="message-text structured-day-content">
                  {linkifyText(day.content)}
                </div>
              )}

              {dayItems.length > 0 && (
                <div className="structured-day-items">
                  {dayItems.map((item, itemIndex) => (
                    <StructuredDayItemCard
                      key={`${item?.title || 'item'}-${itemIndex}`}
                      item={item}
                    />
                  ))}
                </div>
              )}
            </section>
          );
        })}

        {finalization && (
          <div className="message-text structured-message-finalization">
            {linkifyText(finalization)}
          </div>
        )}
      </div>
    );
  }

  if (recommendations.length > 0) {
    return (
      <div className="structured-message">
        {introduction && (
          <div className="message-text recommendation-intro">
            {linkifyText(introduction)}
          </div>
        )}

        <section className="structured-day-block">
          <h3 className="structured-day-title">{t('item.recommendations')}</h3>
          <div className="recommendations-grid">
            {recommendations.map((item, index) => (
              <StructuredDayItemCard
                key={`rec-${index}`}
                item={item}
              />
            ))}
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="structured-message">
      <div className="message-text">
        {linkifyText(introduction)}
      </div>
    </div>
  );
}
